import { v } from "convex/values";

export const EVENT_FEEDBACK_CATEGORIES = [
  "date_time",
  "title",
  "location",
  "description",
  "links_mentions",
  "other",
] as const;

export type EventFeedbackCategory = (typeof EVENT_FEEDBACK_CATEGORIES)[number];

export const eventFeedbackCategoryValidator = v.union(
  v.literal("date_time"),
  v.literal("title"),
  v.literal("location"),
  v.literal("description"),
  v.literal("links_mentions"),
  v.literal("other"),
);

export const ENRICHMENT_FEEDBACK_CATEGORIES = [
  "description",
  "price_tickets",
  "featured",
  "vibe_good_to_know",
  "other",
] as const;

export type EnrichmentFeedbackCategory =
  (typeof ENRICHMENT_FEEDBACK_CATEGORIES)[number];

export const enrichmentFeedbackCategoryValidator = v.union(
  v.literal("description"),
  v.literal("price_tickets"),
  v.literal("featured"),
  v.literal("vibe_good_to_know"),
  v.literal("other"),
);
